import React, { useState, useMemo } from 'react';

import { Report } from '~/components';
import { RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelCotaContrato() {
  const [open, setOpen] = useState(true);
  const [contrato, setContrato] = useState([]);

  const cellsContrato = useMemo(
    () => [
      {
        id: 'idcontrato',
        label: t('s.cadastro.contrato.idcontrato'),
        filter: { type: 'text' },
      },
      {
        id: 'nomecontrato',
        label: t('s.cadastro.contrato.nomecontrato'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    return {
      ...params,
      nomecontrato: contrato.nomecontrato ?? '',
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.relcotacontrato')}
      relatorio="relcotacontrato"
      serialize={(param) => handleSerializeForm(param)}
    >
      <PesquisaTabela
        name="idcontrato"
        label={t('s.menu.cadastro.veiculo.contrato')}
        primary="idcontrato"
        secondary="nomecontrato"
        url="contratos"
        header={cellsContrato}
        getValue={(value) => setContrato(value)}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelCotaContrato;
